export const styles = (theme) => ({
  pin: {
    color: theme.palette.textColor.primary,
    width: 20,
    height: 20,
  },
  content: {
    display: 'grid',
    fontSize: 14,
    lineHeight: 1.4,
    color: theme.palette.textColor.secondary,
    // `body2` carries its own font size, so the rows must be told to follow the container.
    '& > *': {
      fontSize: 'inherit',
      lineHeight: 'inherit',
    },
  },
  greyText: {
    color: theme.palette.textColor.secondary,
  },
  value: {
    color: theme.palette.textColor.dark,
    fontWeight: 500,
  },
  coordinates: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  copy: {
    color: theme.palette.textColor.primary,
    padding: 2,
  },
  mapsLink: {
    justifySelf: 'end',
    marginTop: theme.spacing(1.5),
    padding: 0,
    minWidth: 0,
    textTransform: 'none',
    fontWeight: 500,
    color: theme.palette.textColor.primary,
    '&:hover': {
      backgroundColor: theme.palette.background.transparent,
    },
  },
  mapsIcon: {
    fontSize: 14,
  },
});
